import React, { useEffect, useState } from 'react'
import {useNavigate, Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import menu from '../../photos/gran_rodeo_menu.pdf'
import axios from 'axios';
const MobileNav = (props) => {

    const navigate = useNavigate();

    useEffect(() => {
        if(props.opened == 'open')
        {
            document.getElementById('root').classList.add('no-scroll')
            }
        else{
            document.getElementById('root').classList.remove('no-scroll')
        }
        }, [props.opened]);

    return (
        <div>
            <div className={`mobile-nav ${props.opened}`}>
                <nav className='mobile-nav-menu'>
                    <ul>
                        <li><Link onClick={props.onClose()} to={'/'}>Home</Link></li>
                        <li><Link onClick={props.onClose()} to={menu} target='_blank'>Menu</Link></li>
                        <li><HashLink smooth onClick={props.onClose()} to={'/#hours-of-operation'}>Hours</HashLink></li>
                        <li><Link onClick={props.onClose()} to={'/OnlineOrder'}>Order Online</Link></li>
                        {/* <li><Link onClick={props.onClose()}>Contact</Link></li>
                        <li><Link onClick={props.onClose()}>Montgomeryville</Link></li>
                        <li><Link onClick={props.onClose()}>Warrington</Link></li> */}
                    </ul>
                </nav>
            </div>
        </div>
    )
}
export default MobileNav;